import { Box, Inline, Spread } from 'braid-design-system';
import { vars } from 'braid-design-system/css';

import {
  H2ToggleButton,
  BoldToggleButton,
  ItalicToggleButton,
  BulletListToggleButton,
  NumberedListToggleButton,
  LinkSetButton,
} from 'src/app/shared/components/RichTextEditor';

interface MenuBarProps {
  enableHyperlinks?: boolean;
}

export const MenuBar = ({ enableHyperlinks = false }: MenuBarProps) => (
  <Box
    style={{
      borderBottom: `solid 1px ${vars.borderColor.neutralLight}`,
      position: 'sticky',
    }}
    paddingBottom="xsmall"
    top={0}
    zIndex="sticky"
    background="surface"
  >
    <Spread alignY="center" space="none">
      <Inline space="medium">
        <Inline space="none">
          <H2ToggleButton />
          <BoldToggleButton />
          <ItalicToggleButton />
        </Inline>
        <Inline space="none">
          <BulletListToggleButton />
          <NumberedListToggleButton />
        </Inline>
        {enableHyperlinks && (
          <Inline space="none">
            <LinkSetButton />
          </Inline>
        )}
      </Inline>
    </Spread>
  </Box>
);
